import { tuneSubscribe } from "./TuneSubscribeOption";
import type { TuneSubscribeKey, TuneSubscribeOption } from "./TuneSubscribeOption";

export type InitialSubscriptionTargets = {
  tuneCh: boolean;
  posts: boolean;
  rank: boolean;
  rankAll: boolean;
};

export type SubscriptionPlan = {
  initial: InitialSubscriptionTargets;
  streams: TuneSubscribeKey[];
};

export const buildInitialSubscriptionTargets = (
  tuneOption: TuneSubscribeOption
): InitialSubscriptionTargets => ({
  tuneCh: Boolean(
    tuneOption[tuneSubscribe.stateTuneChLatestPost] ||
    tuneOption[tuneSubscribe.stateTuneChMeta]
  ),
  posts: Boolean(tuneOption[tuneSubscribe.statePosts]),
  rank: Boolean(tuneOption[tuneSubscribe.stateRank]),
  rankAll: Boolean(tuneOption[tuneSubscribe.stateRankAll]),
});
